<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  metaInfo: {
    title: 'Spotlight',
  },
  data: () => ({
    //
  }),

}
</script>
<style lang="scss">
@import 'styles/custom';
</style>
